import React from 'react';
import GenericInternalTransfer from '../GenericInternalTransfer';

const ElectricalGoodsInternalTransfer = () => (
  <GenericInternalTransfer
    sectionName="Electrical Goods"
    sectionKey="Electrical Goods"
    backRoute="/sections/electrical-goods"
  />
);

export default ElectricalGoodsInternalTransfer;
